const EnumTriggerType = {
  SYSTEM: "SYSTEM",
  USER: "USER",
};

export default EnumTriggerType;
